import {useQuery} from 'react-query'
 import {ExtraEditModalForm} from './ExtraEditModalForm'
//  import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
 import {getExtraById} from '../core/_requests'
import { QUERIES, isNotEmpty } from '../../../../../_metronic/helpers'

const ExtraEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const dataresponse = {name:"demo"}
  const {
    isLoading,
    data: extra,
    error,
  } = useQuery(
    `${QUERIES.AREAS_LIST}-extra-${itemIdForUpdate}`,
    () => {
      return getExtraById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
       // setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <ExtraEditModalForm isExtraLoading={false} extra={{id: undefined}} />
  }

  if (itemIdForUpdate) {
    return <ExtraEditModalForm isExtraLoading={false} extra={dataresponse} />
  }

  return null
}

export {ExtraEditModalFormWrapper}
